// @flow

export const USER_RESULT_TYPE = 'user';
export const STUDENT_RESULT_TYPE = 'student_profile';
export const PARENT_RESTULT_TYPE = 'parent_profile';
export const BUS_RESULT_TYPE = 'bus';
export const ROUTE_RESULT_TYPE = 'route';
export const ROUTE_STOP_RESULT_TYPE = 'route_stop';
export const GATEWAY_RESULT_TYPE = 'gateway';
export const GATE_RESULT_TYPE = 'gate';


// WEBPACK FOOTER //
// ./src/scripts/components/OmnisearchResult/types.js